import { DateTime } from 'luxon';

export default function getFirstDayOfWeek() {
  // If no specific locale is set, we assume Monday (1) as the default
  // Modify this if you need to account for different locales.
  const userLocale = DateTime.local().locale;

  // Check for specific locales (e.g., U.S. -> Sunday is the first day of the week)
  if (userLocale === 'en-US') {
    return 0; // Sunday
  }
  // Default to Monday (ISO standard)
  return 1; // Monday
}
